export const ImageCasino = [
  {
    ch: 'SEXY',
    img: '/static/img/game/casino/SexyGaming.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'SAGAME',
    img: '/static/img/game/casino/sa.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'PRAGMATIC',
    img: '/static/img/game/casino/pragmaticplay.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'XTREME',
    img: '/static/img/game/casino/XTREME.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'WM',
    img: '/static/img/game/casino/WM.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'DREAM2',
    img: '/static/img/game/casino/dream.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'EBET',
    img: '/static/img/game/casino/ebet.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'ALLBET',
    img: '/static/img/game/casino/allbet.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'PRETTY',
    img: '/static/img/game/casino/prettygaming.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
  {
    ch: 'AGGAME',
    img: '/static/img/game/casino/ag.png', //
    gameType: 'LIVECASINO',
    category: 'LIVECASINO',
  },
]
export const ImageSlot = [
  {
    ch: 'PGSOFT2',
    img: '/static/img/game/slot/pg.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'SLOTXO',
    img: '/static/img/game/slot/slotXO.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'JILI',
    img: '/static/img/game/slot/JILI.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'PRAGMATIC',
    img: '/static/img/game/slot/pragmaticplay.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'CQ9',
    img: '/static/img/game/slot/CQ9.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'SPADE',
    img: '/static/img/game/slot/spadegaming.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'AMBSLOT',
    img: '/static/img/game/slot/AMB.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'ASKMEBET',
    img: '/static/img/game/slot/ask-me-bet.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'MICRO',
    img: '/static/img/game/slot/microgaming.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'GAMATRON',
    img: '/static/img/game/slot/gamatron.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'MANNA',
    img: '/static/img/game/slot/Mp.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'NETENT2',
    img: '/static/img/game/slot/NETENT2.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'KINGMAKER',
    img: '/static/img/game/slot/KINGMAKER.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'SIMPLEPLAY',
    img: '/static/img/game/slot/simpleplay.png', //
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
  {
    ch: 'ep',
    img: '/static/img/game/slot/evoplay2.png',
    gameType: 'EGAMES',
    category: 'EGAMES',
  },
]
export const ImagePOKER = [
  {
    ch: 'AMBPOKER',
    img: '/static/img/game/card/AMBPOKER.png', //
    gameType: 'EGAMES',
    category: 'POKER',
  },
]
export const ImageTRADING = [
  {
    ch: 'HOTGRAPH',
    img: '/static/img/game/TRADING/TRADING.png', //
    gameType: 'TRADING',
    category: 'TRADING',
  },
]



// WEBPACK FOOTER //
// ./src/config/Game.js